<template>
  <div>
    <div class="banner">
      <el-image src="https://sritrang.oss-cn-shanghai.aliyuncs.com/202108/2021082503011487.jpg"></el-image>
      <div class="cover">
        <h1>荣誉奖项</h1>
        <div class="subtitle">关于诗董</div>
      </div>
    </div>
    <div class="search ">
      <el-form :inline="true">
        <el-form-item label="年份">
          <el-select v-model="year" clearable @change="change">
            <el-option :value="2009">2009</el-option>
            <el-option :value="2010">2010</el-option>
            <el-option :value="2011">2011</el-option>
            <el-option :value="2012">2012</el-option>
            <el-option :value="2013">2013</el-option>
            <el-option :value="2014">2014</el-option>
            <el-option :value="2015">2015</el-option>
            <el-option :value="2016">2016</el-option>
            <el-option :value="2017">2017</el-option>
            <el-option :value="2018">2018</el-option>
            <el-option :value="2019">2019</el-option>
          </el-select>
        </el-form-item>
      </el-form>
    </div>
    <div class="clearfix"></div>
    <div class="list">
      <el-row :gutter="50">
        <el-col :span="8" v-for="(item,index) in tableList" :key="index">
          <div class="item">
            <div class="new-info">
              <el-image fit="contain" :src="item['coverUrl']"></el-image>
            </div>
            <div class="desc">
              <div class="time">{{ item['year'] }}</div>
              <div class="title"><a href="">{{ item['name'] }}</a></div>
            </div>
          </div>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import {getAwardsIndex} from '@/api/api'

export default {
  name: "Index",
  data() {
    return {
      tableData: [],
      tableList: [],
      year: 2019
    }
  },
  created() {
    this.getIndex();
  },
  methods: {
    getIndex() {
      getAwardsIndex().then((res) => {
        this.tableData = res.data;
        this.getList();
      })
    },
    change(e) {
      console.log(e);
      this.getList();
    },
    getList() {
      console.log(this.year)
      let data = [];
      for (let i = 0; i < this.tableData.length; i++) {
        let item = this.tableData[i];
        if (this.year + "年" == item.year) {
          data.push(item);
        }
      }
      this.tableList = data;
    }
  }
}
</script>

<style scoped>
@import url("Index.css");
</style>